
import Vue from "vue";
import { DeviceHistorySchema, VehicleSchema } from "@/commons/client";
import VehicleAssignmentDialog from "@/components/VehicleAssignmentDialog.vue";

export default Vue.extend({
  name: "DeviceHistoryList",
  components: { VehicleAssignmentDialog },

  data: () => ({
    search: "",
    queryData: {
      perPage: 5,
      currentPage: 1,
      organization_id: 1,
    },
    loading: false,
    headers: [
      {
        text: "Seriale",
        align: "start",
        sortable: false,
        value: "current_device_id",
      },
      { text: "Veicolo (stato)", value: "current_vehicle_id" },
      { text: "Ultimo Giorno", value: "last_day_data" },
      { text: "Azioni", value: "actions", sortable: false },
    ],
  }),

  computed: {
    devices(): DeviceHistorySchema[] {
      return this.$store.state.deviceHistories;
    },
    vehicles(): VehicleSchema[] {
      return this.$store.state.vehicles;
    },
    filteredDevices(): DeviceHistorySchema[] {
      if (!this.search) return this.devices;
      const q = this.search.toLowerCase().trim();
      return this.devices.filter((d) => {
        const seriale = (d.current_device_id || "").toLowerCase();
        const plate = (d.current_vehicle_id || "").toLowerCase();
        return seriale.includes(q) || plate.includes(q);
      });
    },
  },
});
